import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useSearchParams } from "react-router-dom";
import { useCurrentParams } from "../../hooks/useCurrentParams";

const FilterByGenres = ({ currentTab, moviesGenres, tvGenres }) => {
  const [genres] = useAutoAnimate();

  const [searchParam, setSearchParam] = useSearchParams();
  const [currentSearchParams] = useCurrentParams();

  const chooseGenre = (genreId) => {
    const existingGenres = searchParam.getAll("genre");

    if (existingGenres.includes(genreId)) {
      const newGenres = existingGenres.filter((genre) => genre !== genreId);
      setSearchParam({
        ...currentSearchParams,
        genre: newGenres,
      });
    } else {
      setSearchParam({
        ...currentSearchParams,
        genre: [...existingGenres, genreId],
      });
    }
  };

  return (
    <ul
      ref={genres}
      className="flex gap-y-3 gap-x-2 flex-wrap max-h-[160px] overflow-y-auto tw-light-scroll"
    >
      {currentTab === "movie" &&
        Object.entries(moviesGenres).map((genre) => (
          <li key={genre[0]}>
            <button
              onClick={() => chooseGenre(String(genre[0]))}
              className={`px-4 py-2 rounded-full tw-shaded-button text-sm transition duration-300
              hover:shadow-md hover:shadow-gray-darken hover:text-white ${
                searchParam.getAll("genre").includes(String(genre[0])) &&
                "shadow-md shadow-gray-darken text-white"
              }`}
            >
              {genre[1]}
            </button>
          </li>
        ))}
      {currentTab === "tv" &&
        Object.entries(tvGenres).map((genre) => (
          <li key={genre[0]}>
            <button
              onClick={() => chooseGenre(String(genre[0]))}
              className={`px-4 py-2 rounded-full tw-shaded-button text-sm transition duration-300 
              hover:shadow-md hover:shadow-gray-darken hover:text-white ${
                searchParam.getAll("genre").includes(String(genre[0])) &&
                "shadow-md shadow-gray-darken text-white"
              }`}
            >
              {genre[1]}
            </button>
          </li>
        ))}
    </ul>
  );
};

export default FilterByGenres;
